module.exports = __webpack_public_path__ + "img/c-03.60ec2946.jpg";